import React, { HTMLAttributes } from 'react';

const DocumentUpload = ({
  className,
}: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="4.12 0 23.75 32"
  >
    <path d="M26.625 0H11a.63.63 0 0 0-.442.183l-6.25 6.25a.63.63 0 0 0-.183.442V28.25c0 .69.56 1.25 1.25 1.25h7.5v1.25c0 .69.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25V29.5h7.5c.69 0 1.25-.56 1.25-1.25v-27c0-.69-.56-1.25-1.25-1.25Zm-16.25 2.134V6.25H6.26l4.116-4.116Zm7.5 24.116v4.5h-3.75v-4.5a.625.625 0 0 0-.625-.625h-1.231a.01.01 0 0 1-.01-.01c0-.002 0-.003.006-.01l3.728-3.727a.01.01 0 0 1 .007-.003c.002 0 .005 0 .006.003l3.732 3.73a.01.01 0 0 1 0 .014c-.002.001-.003.003-.007.003H18.5a.625.625 0 0 0-.625.625Zm8.75 2h-7.5v-1.375h.606a1.26 1.26 0 0 0 .89-2.15l-3.73-3.731a1.26 1.26 0 0 0-1.781 0l-3.726 3.725a1.26 1.26 0 0 0 .884 2.156h.607v1.375h-7.5V7.5h5c.69 0 1.25-.56 1.25-1.25v-5h15v27Z" />
    <path d="M23.5 11.875H11.312a.625.625 0 0 0 0 1.25H23.5a.625.625 0 0 0 0-1.25Zm0 2.813h-15a.625.625 0 0 0 0 1.25h15a.625.625 0 0 0 0-1.25Zm-15-5.625a.625.625 0 0 0 0 1.25h15a.625.625 0 0 0 0-1.25h-15ZM16 17.5H8.5a.625.625 0 0 0 0 1.25H16a.625.625 0 0 0 0-1.25Zm-7.5-4.375a.625.625 0 0 0 0-1.25.625.625 0 1 0 0 1.25Z" />
  </svg>
);

export default DocumentUpload;
